import React from 'react';
import { whoWeHelpList } from '../../data/mock';
import { CheckCircle, AlertCircle, Building, Briefcase, TrendingDown } from 'lucide-react';

const icons = [AlertCircle, Building, Building, Briefcase, TrendingDown];

const WhoWeHelpSection = () => {
  return (
    <section className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      
      {/* Decorative Circles */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-500 rounded-full blur-3xl opacity-10"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-amber-500 rounded-full blur-3xl opacity-10"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-emerald-500/20 text-emerald-400 rounded-full text-sm font-semibold mb-4">
            We're Here to Help
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Who We Help
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            No matter your situation, we have solutions tailored to your needs.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {whoWeHelpList.map((item, index) => {
            const IconComponent = icons[index] || CheckCircle;
            return (
              <div 
                key={item}
                className="flex items-start gap-4 p-6 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-emerald-500/30 transition-all duration-300 group"
              >
                <div className="w-10 h-10 rounded-lg bg-emerald-500/20 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-500/30 transition-colors">
                  <IconComponent className="w-5 h-5 text-emerald-400" />
                </div>
                <span className="text-white font-medium leading-relaxed">
                  {item}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelpSection;
